import React, { useMemo } from 'react'

const FREQUENCIES = [
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Annual', label: 'Annual' },
]

const MIN_YEAR = 1990

function DataCenterPeriodPanel({ frequency, onFrequencyChange, yearFrom, yearTo, onYearFromChange, onYearToChange }) {
  const maxYear = new Date().getFullYear()
  const years = useMemo(() => {
    const list = []
    for (let y = maxYear; y >= MIN_YEAR; y -= 1) list.push(y)
    return list
  }, [maxYear])

  const applyPreset = (preset) => {
    if (preset === 'full') {
      onYearFromChange(MIN_YEAR)
      onYearToChange(maxYear)
      return
    }
    const span = Number(preset)
    onYearFromChange(Math.max(MIN_YEAR, maxYear - span + 1))
    onYearToChange(maxYear)
  }

  return (
    <div className="dc-panel" id="dcPanelPeriod">
      <div className="dc-panel-head">
        <div className="dc-panel-head-left">
          <span className="dc-badge-step">4</span>
          <div>
            <h2 className="dc-panel-title">Frequency &amp; period</h2>
            <span className="dc-panel-sub">Applied to every selected indicator</span>
          </div>
        </div>
      </div>
      <div className="dc-panel-body">
        <div className="dc-field">
          <div className="dc-label"><span>Frequency</span></div>
          <div className="dc-seg">
            {FREQUENCIES.map((f) => (
              <button
                type="button"
                key={f.value}
                className={frequency === f.value ? 'is-on' : ''}
                onClick={() => onFrequencyChange(f.value)}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>
        <div className="dc-field">
          <div className="dc-label"><span>Date range</span></div>
          <div className="dc-range">
            <div className="dc-range-field">
              <label htmlFor="dcYearFrom">From</label>
              <select className="dc-select" id="dcYearFrom" value={yearFrom} onChange={(e) => onYearFromChange(Number(e.target.value))}>
                {years.filter((y) => y <= yearTo).map((y) => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>
            <div className="dc-range-field">
              <label htmlFor="dcYearTo">To</label>
              <select className="dc-select" id="dcYearTo" value={yearTo} onChange={(e) => onYearToChange(Number(e.target.value))}>
                {years.filter((y) => y >= yearFrom).map((y) => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>
          </div>
          <div className="dc-range-presets">
            <button type="button" className="dc-subtab" onClick={() => applyPreset('5')}>Last 5 years</button>
            <button type="button" className="dc-subtab" onClick={() => applyPreset('10')}>Last 10 years</button>
            <button type="button" className="dc-subtab" onClick={() => applyPreset('20')}>Last 20 years</button>
            <button type="button" className="dc-subtab" onClick={() => applyPreset('full')}>Full history</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DataCenterPeriodPanel
